// extracted by mini-css-extract-plugin
module.exports = {"button":"_2d625","icon":"f8a3f","facebook":"fc4c0","google":"_5e845","disabled":"b9b4e"};